/**
 * OpenAlex desde el navegador (#47). El acceso sin clave tiene un presupuesto diario por IP
 * (~0,10 $, unas 100 búsquedas). Desde el Worker no sirve: las IP de Cloudflare se comparten con
 * miles de Workers y ese cupo siempre está agotado. Desde el navegador cada persona usa el suyo,
 * así que la clave del proyecto (1 $/día) solo se gasta cuando el de la persona se acaba.
 *
 * En el navegador no hay límite de 10 ms de CPU: páginas de 50 en lugar de 15.
 */

import type { SearchPage, SearchRequest } from "../core/models";
import { searchPage } from "../worker/openalex";

export const OPENALEX_URL = "https://api.openalex.org/works";
export const BROWSER_PAGE_SIZE = 50;

/**
 * Una página de OpenAlex sin clave, pedida por el navegador. Si falla (cupo agotado, red, CORS),
 * `fallback` la pide al Worker con la clave del proyecto.
 */
export async function openalexSearch(
  fetchFn: typeof fetch,
  req: SearchRequest,
  fallback: (req: SearchRequest) => Promise<SearchPage>,
): Promise<SearchPage> {
  // El cursor de una página del Worker (con otro tamaño de página) no vale aquí: se sigue allí
  if (req.cursor?.startsWith("w:")) return fallback({ ...req, cursor: req.cursor.slice(2) }).then(tagWorker);
  try {
    return await searchPage(
      fetchFn,
      OPENALEX_URL,
      "",
      { query: req.query, sort: req.sort, cursor: req.cursor, pageSize: BROWSER_PAGE_SIZE, titleAbsOnly: req.title_abs_only ?? true },
      1,
    );
  } catch {
    // Las páginas que vengan del Worker llevan su cursor marcado para seguir pidiéndolas allí
    return fallback({ ...req, cursor: undefined }).then(tagWorker);
  }
}

const tagWorker = (page: SearchPage): SearchPage => ({ ...page, next_cursor: page.next_cursor ? `w:${page.next_cursor}` : null });
